import React from 'react';
import {
  Grid,
  Button,
  Box,
  Paper,
  ClickAwayListener,
  Typography,
} from '@mui/material';
import RoomInfoContainer from './RoomInfoContainer';
import RoomSummary from './RoomSummary';

const RoomButtonAndModal = ({
  roomInfo,
  setRoomInfo,
  quantity,
  setQuantity,
  showRooms,
  setShowRooms,
  updatepassengerValues,
}) => {
  const open = Boolean(showRooms);

  const handleClick = e => setShowRooms(e.currentTarget);
  const handleClose = () => setShowRooms(null);

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Grid item xs={12} md={12}>
        <Button
          variant="outlined"
          fullWidth
          onClick={e => {
            e.stopPropagation();
            handleClick(e);
          }}
          sx={{
            height: 55,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0 12px',
            borderRadius: '3px',
            background: '#FFFFFF',
            width: '100%',
            color: '#000000',
            margin: 0,
            marginRight: '63px',
          }}
        >
          <Grid container>
            <Grid
              item
              sx={{
                display: {
                  xs: 'none',
                  md: 'block',
                },
              }}
            >
              <Typography
                sx={{ fontSize: '14px', fontWeight: 600, color: '#636466' }}
              >
                Habitaciones
              </Typography>
            </Grid>
            <Grid item container justifyContent="flex-end">
              <RoomSummary roomInfo={roomInfo} />
            </Grid>
          </Grid>
        </Button>
      </Grid>

      {open && (
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            sx={{
              position: 'absolute',
              top: '100%',
              left: 0,
              overflowY: 'overlay',
              border: '1px solid #E5E5E5',
              padding: '1rem',
              zIndex: 1300,
              backgroundColor: '#fff',
              '&::-webkit-scrollbar': { display: 'none' }, // Chrome, Edge, Safari
              scrollbarWidth: 'none', // Firefox
              msOverflowStyle: 'none', // IE 10+,
              overflow: 'visible',
            }}
          >
            <RoomInfoContainer
              showRooms={open}
              passengersValue={passengers =>
                updatepassengerValues({ passengers })
              }
              setRoomInfo={setRoomInfo}
              quantity={quantity}
              setQuantity={setQuantity}
              hanleListo={handleClose}
            />
          </Paper>
        </ClickAwayListener>
      )}
    </Box>
  );
};

export default RoomButtonAndModal;
